import React, { ReactNode, useState } from 'react';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Modal } from '@eika/modal';

import { meldSkadeNamespace } from '../../index';
import { ModalType } from '../../types/generated-types';
import { assertUnreachable } from '../../utils/compiler-utils';
import { getModalButtonText } from './modal-sporsmal-utils';

type ModalContentProps = {
    modalType: ModalType;
};

const ModalContent = ({ modalType }: ModalContentProps): ReactNode => {
    switch (modalType) {
        case ModalType.Normaltap:
            return (
                <>
                    <h2>Normaltap</h2>
                    <h3 className="typography-subtitle">Hva er normaltapet?</h3>
                    <p>
                        Normaltapet er besetningens gjennomsnittstap de siste 3 årene. Store og uforutsette ulykker som
                        rammer besetning og som kan føres tilbake til samme skadeårsak, skal ikke brukes i beregningen
                        av normaltapet. Sykdom som medfører pålegg fra Mattilsynet skal heller ikke brukes i
                        beregningen.
                    </p>
                    <h3 className="typography-subtitle">Hvordan finner jeg normaltapet?</h3>
                    <p>
                        Normaltapet kan du finne ved å logge inn på for eksempel{' '}
                        <Link
                            icon={IconTypes.EKSTERN_24}
                            href="https://medlem.tine.no/gard-og-drift/husdyrkontrollen"
                            linkType="inline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Husdyrkontrollen
                        </Link>
                        for melkeku eller{' '}
                        <Link
                            icon={IconTypes.EKSTERN_24}
                            href="https://www.animalia.no/"
                            linkType="inline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Animalia
                        </Link>
                        og finne årsutskriftene med helserapporter.
                    </p>
                </>
            );
        default:
            return assertUnreachable(modalType);
    }
};

type ModalProps = {
    id: string;
    modalType: ModalType;
};

export const ModalSporsmal = ({ id, modalType }: ModalProps) => {
    const [openModal, setOpenModal] = useState<boolean>(false);

    return (
        <>
            <div className="container__standard-width container__standard-width__attention-message">
                <LinkButton onClick={() => setOpenModal(true)}>{getModalButtonText(modalType)}</LinkButton>
            </div>
            <Modal
                appNamespace={meldSkadeNamespace}
                id={id}
                open={openModal}
                setOpen={setOpenModal}
                onClose={() => setOpenModal(false)}
            >
                <ModalContent modalType={modalType} />
            </Modal>
        </>
    );
};
export default ModalSporsmal;
